import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { TweenLite } from 'gsap';

import SliderHandle from './SliderHandle';
import './styles.styl';

class Slider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focused: false,
      currentStep: 0
    };

    this.sliderRef = null;
    this.handleRef = null;
  }

  UNSAFE_componentWillMount = () => {
    const { validationResult, input, data } = this.props;
    if (validationResult !== null) {
      // this function positions the elements in the slider when navigating back to this question after completing
      data.options.forEach((option, optionIndex) => {
        if (option.label === input) {
          return this.setState({
            currentStep: optionIndex + 1
          });
        }
      });
    }
  };

  componentDidMount() {
    if (this.state.currentStep > 0) {
      this.moveHandleToCurrentStep();
    }
    window.addEventListener('resize', this.moveHandleToCurrentStep);
  }

  componentDidUpdate(prevProps, prevState) {
    const { input, validationResult } = this.props;
    const { options } = this.props.data;

    if (prevProps.input && !input) {
      this.setState({
        currentStep: 0
      });
    }
    if (validationResult !== null && prevProps.input !== input) {
      options.forEach((option, i) => {
        if (option.label === input) {
          this.setState({
            currentStep: i + 1
          });
        }
      });
    }
    if (!this.state.focused) {
      this.moveHandleToCurrentStep();
    }
  }

  setSliderRef = element => {
    this.sliderRef = element;
  };

  setHandleRef = element => {
    this.handleRef = element;
  };

  handleStart = () => {
    document.addEventListener('mousemove', this.handleDrag);
    document.addEventListener('mouseup', this.handleEnd);
    this.setState({ focused: true });
  };

  handleDrag = e => {
    const { focused } = this.state;
    const x = e.touches ? e.touches[0].pageX : e.pageX;
    if (focused) {
      this.moveHandle(x);
    }
  };

  handleEnd = () => {
    const { options } = this.props.data;

    const sliderBox = this.sliderRef.getBoundingClientRect();
    const handleBox = this.handleRef.getBoundingClientRect();

    const handleX = this.handleRef._gsTransform.x + handleBox.width / 2;
    const stepMultiple = sliderBox.width / options.length;
    const closestStep = Math.round(handleX / stepMultiple);
    const step = closestStep > options.length ? options.length : closestStep;

    this.handleInput(step);

    document.removeEventListener('mousemove', this.handleDrag);
    document.removeEventListener('mouseup', this.handleEnd);
  };

  handleKeyDown = e => {
    const { options } = this.props.data;
    const { currentStep } = this.state;

    if (
      (e.key === 'ArrowLeft' && currentStep > 0) ||
      (e.key === 'ArrowRight' && currentStep < options.length)
    ) {
      let newStep = e.key === 'ArrowLeft' ? currentStep - 1 : currentStep + 1;
      this.handleInput(newStep);
    }
  };

  moveHandle = pointerPosition => {
    if (this.props.validationResult !== null) return;

    const handleBox = this.handleRef.getBoundingClientRect();
    const sliderBox = this.sliderRef.getBoundingClientRect();

    // Get position of mouse relative to slider
    const pointerX = pointerPosition - sliderBox.left;

    // Get new position of handle
    const newHandleX = pointerX - handleBox.width / 2;

    if (pointerX >= 0 && pointerX <= sliderBox.width) {
      TweenLite.set(this.handleRef, {
        x: newHandleX,
        yPercent: -50
      });
    }
  };

  handleInput = step => {
    const { data, handleInput, validationResult } = this.props;

    if (validationResult === null) {
      this.setState({
        focused: false,
        currentStep: step
      });

      if (step - 1 >= 0) {
        let newInput = {
          [data.question]: data.options[step - 1].label
        };
        handleInput(newInput);
      }
    }
  };

  moveHandleToCurrentStep = () => {
    const { currentStep } = this.state;
    const { options } = this.props.data;

    const handleBox = this.handleRef.getBoundingClientRect();
    const sliderBox = this.sliderRef.getBoundingClientRect();
    const stepMultiple = sliderBox.width / options.length;
    const newHandleX = stepMultiple * currentStep - handleBox.width / 2;

    TweenLite.to(this.handleRef, 0.2, {
      x: newHandleX,
      yPercent: -50
    });
  };

  renderSliderStep = () => {
    const { options } = this.props.data;
    const offsetPercentage = 100 / options.length;

    return options.map((option, index) => {
      return (
        <div
          className="slider__step"
          key={option.value}
          style={{
            left: `${offsetPercentage * (index + 1)}%`
          }}
        >
          <div className="slider__step-marker" />
          <p className="slider__step-label text-bold">{option.label}</p>
        </div>
      );
    });
  };

  render() {
    const { image, imageAltText, question, options } = this.props.data;
    const { focused } = this.state;

    return (
      <Fragment>
        <img
          className="img-center margin-m"
          src={image}
          alt={imageAltText}
          width="568"
          height="235"
        />
        <h3 className="text-bold">{question}</h3>
        <div className="slider">
          <div ref={this.setSliderRef} className="slider__track">
            {/* This is the first option, and is not assigned a value or corresponding label */}
            <div className="slider__point">
              <div className="slider__point-marker" />
            </div>
            {this.renderSliderStep()}
            <SliderHandle
              setRef={this.setHandleRef}
              steps={options.length}
              onMouseDown={this.handleStart}
              onTouchStart={this.handleStart}
              onTouchMove={this.handleDrag}
              onTouchEnd={this.handleEnd}
              onKeyDown={this.handleKeyDown}
              isFocused={focused}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

Slider.defaultProps = {};

Slider.propTypes = {
  data: PropTypes.object.isRequired
};

export default Slider;



// WEBPACK FOOTER //
// ../core/src/components/Slider/Slider.js